module.exports = __webpack_public_path__ + "static/media/companydefault.adb16ae9.png";